import React from "react";

function Custom404() {
  return <div>Custom404</div>;
}

export default Custom404;
